import { useState } from 'react';
import { getClientSongCollectionStats, SongCollectionStats } from '@round/api';
import useAbortableEffect from '../../../../Hooks/useAbortableEffect';

export default function useClientSongCollectionStats(clientId: number, collectionId: number | undefined) {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [stats, setStats] = useState<SongCollectionStats | null>(null);

    useAbortableEffect(
        (signal) => {
            async function fetchData() {
                if (!collectionId) {
                    return;
                }

                try {
                    setIsLoading(true);
                    setError(null);
                    const response = await getClientSongCollectionStats({ clientId, collectionId }, { signal });
                    if (response.status === 404) {
                        setError(response.data.error);
                        return;
                    }

                    setStats(response.data);
                } catch (e) {
                    if (e instanceof Error && e.name === 'AbortError') {
                        return;
                    }

                    setError('Could not fetch stats');
                } finally {
                    setIsLoading(false);
                }
            }

            fetchData();
        },
        [clientId, collectionId]
    );

    return {
        isLoading,
        error,
        stats,
        reset: () => {
            setStats(null);
            setError(null);
            setIsLoading(false);
        },
    };
}
